import { Modal } from "../ui/components/Modal";
import { debounce } from "../utils/debounce";

export class RechargeModal extends Modal {
    minMinutes = null;

    async init() {
        this.minMinutes = this.extractMinMinutesFromAlert();
        this.updateResultFromServer();

        this.minutesInput.on("input", () => {
            this.minutesInput.el().value = this.minutesInput
                .el()
                .value.replace(/\D+/g, "");
            this.minErrorAlert.hide();
            debounce("rechargeModalUpdate", () => {
                this.updateResultFromServer();
            }, 500);
        });

        this.payBtn.on("click", () => this.validateAndProceed());

        this.cancelPayBtn.forEach((item) => {
            item.on("click", () => {
                this.minutesInput.el().value = "";
                this.minErrorAlert.hide();
                this.updateResultFromServer();
            });
        });
    }

    extractMinMinutesFromAlert() {
        const text = this.minErrorAlert.el().textContent;
        const match = text.match(/\d+/);
        return match ? Number(match[0]) : 1;
    }

    async updateResultFromServer() {
        let minutes = Number(this.minutesInput.el().value.trim());

        if (!minutes || minutes < this.minMinutes) {
            minutes = this.minMinutes;
        }

        const baseUrl = this.minutesInput.el().dataset.tbxUrl;
        const url = baseUrl.includes("?")
            ? `${baseUrl}&minutes=${minutes}`
            : `${baseUrl}?minutes=${minutes}`;

        const response = await fetch(url);
        const json = await response.json();

        const offer = json.data?.offers?.find((o) => o.type === "payperminute");
        if (offer) {
            this.totalText.el().innerHTML = offer.description;
            this.payMinute.el().innerHTML = offer.formatted_minute_cost;
        }
    }

    validateAndProceed() {
        const minutes = Number(this.minutesInput.el().value.trim());

        if (!minutes || minutes < this.minMinutes) {
           
            this.minErrorAlert.show();
            this.minutesInput.el().focus();
            return false;
        }

        this.redirectToPayment(minutes);
        return true;
    }

    redirectToPayment(minutes) {
        const baseUrl = this.payBtn.el().dataset.tbxUrl;

        const url = baseUrl.includes("?")
            ? `${baseUrl}&minutes=${minutes}`
            : `${baseUrl}?minutes=${minutes}`;

        window.location.href = url;
    }
}
